import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import Franchise from "./pages/Franchise";
import Categories from "./pages/Categories";
import { OurStory, Blog, FAQs, ContactUs, StoreLocator, HelpCenter, PrivacyPolicy, Terms } from "./pages/InfoPages";
import ProductDetail from "./pages/ProductDetail";
import SearchResults from "./pages/SearchResults";
import Admin from "./pages/Admin";
import EnquiryWidget from "./components/EnquiryWidget";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
};

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop-by-age" element={<CategoryPage slug="shop-by-age" key="shop-by-age" />} />
            <Route path="/toys-games" element={<CategoryPage slug="toys-games" key="toys-games" />} />
            <Route path="/learning-education" element={<CategoryPage slug="learning-education" key="learning-education" />} />
            <Route path="/gifts" element={<CategoryPage slug="gifts" key="gifts" />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/store-locator" element={<StoreLocator />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <EnquiryWidget />
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </StoreProvider>
    </div>
  );
}

export default App;
